export const WORKSPACE_TYPES = {
    SHIPPING: 1,
    CUTTING: 2,
    BINDERY: 3,
    ORDERS: 4,
    SIGNATURES: 5,
    LABEL_GENERATION: 6,
    OFFSET_PRINT: 7,
    JOB_PRODUCTS: 8
} as const

const REPORT_ITEM_TYPES = {
    ECOM_JOB: 10,
    ECOM_ORDER: 15,
    PM_JOB: 20,
    FB_JOB: 30,
    PM_ORDER: 40,
    FB_ORDER: 50,
    ORDER_SIG: 60,
    PRINT_FB_JOB: 70,
    PM_JOB_PRINT: 80,
    CUTTING_JOB: 90,
    PRODUCT_JOB: 100
} as const

const REPORT_OBJECT_TYPES = {
    JOB: 1,
    ORDER: 2,
    OTHER_TASK: 3
} as const

const REPORT_TASK_STATUSES = {
    CREATED: 'UTWORZONA',
    INTERRUPTED: 'WSTRZYMANA'
} as const

const REPORT_MATERIAL_STATUSES = {
    NOT_REPORTED: 'NOT_REPORTED'
} as const

const OPERATOR_REPORTING_QR_TYPE_CODES: string[] = ['KZ', 'KP']
const REPORTING_WORKSPACE_TYPE_IDS = [
    WORKSPACE_TYPES.CUTTING,
    WORKSPACE_TYPES.BINDERY,
    WORKSPACE_TYPES.ORDERS,
    WORKSPACE_TYPES.SIGNATURES,
    WORKSPACE_TYPES.OFFSET_PRINT
] as const
const OPERATOR_REPORTING_JOB_REPORT_ITEM_TYPE_IDS: number[] = [
    REPORT_ITEM_TYPES.ECOM_JOB,
    REPORT_ITEM_TYPES.PM_JOB,
    REPORT_ITEM_TYPES.FB_JOB
]
const OPERATOR_REPORTING_ORDER_REPORT_ITEM_TYPE_IDS: number[] = [
    REPORT_ITEM_TYPES.ECOM_ORDER,
    REPORT_ITEM_TYPES.PM_ORDER,
    REPORT_ITEM_TYPES.FB_ORDER,
    REPORT_ITEM_TYPES.ORDER_SIG
]
const OPERATOR_REPORTING_DEFAULT_SHIPPING_GROUP_CODES = ['S', 'B', 'W', 'C'] as const
const CREATE_REPORT_PARAMETER_ORDER = [
    'format',
    'objętość',
    'składki',
    'rodzaj oprawy',
    'papier wnętrz',
    'uszlachetnianie wnętrz',
    'papier okładki',
    'uszlachetnianie okładki'
] as const
const CREATE_REPORT_PRODUCT_TYPE_VISIBLE_REPORT_ITEM_TYPE_IDS: number[] = [
    REPORT_ITEM_TYPES.ECOM_ORDER,
    REPORT_ITEM_TYPES.PM_ORDER,
    REPORT_ITEM_TYPES.FB_ORDER,
    REPORT_ITEM_TYPES.ORDER_SIG
]
const CREATE_PRINT_REPORT_PARAMETER_ORDER = [
    'sposób druku',
    'papier',
    'format A',
    'format B',
    'nakład netto',
    'makulatura na przyrząd',
    'makulatura na bieg',
    'czas przyrządu',
    'czas biegu',
    'kolorystyka strona A',
    'kolorystyka strona B',
    'wzór kolorystyczny',
    'lakier strona A',
    'lakier strona B',
    'liczenie arkuszy co'
] as const
const CREATE_PRINT_REPORT_SIDE_TYPES = {
    A: 'A',
    B: 'B',
    AB: 'AB'
} as const
const CREATE_PRINT_REPORT_SIDE_PRIORITY = [
    CREATE_PRINT_REPORT_SIDE_TYPES.AB,
    CREATE_PRINT_REPORT_SIDE_TYPES.B,
    CREATE_PRINT_REPORT_SIDE_TYPES.A
] as const
const CREATE_PRINT_REPORT_MODE_TYPES = {
    SINGLE: 'single',
    DOUBLE: 'double',
    DOUBLE_SW: 'double-sw'
} as const
const CREATE_PRINT_REPORT_PLATE_SET_COUNT_PARAMETER_NAME = 'ilość kompletów płyt'
const CREATE_PRINT_REPORT_MAX_SHEETS_PER_PLATE_SET_PARAMETER_NAME = 'próg wymiany kompletu płyt'
const CREATE_PRINT_REPORT_NEXT_TASKS_LIMIT = 3 as const
const REPORT_QR_CODE_SIZE = 130 as const
const RUNTIME_COMMENT_CODES = {
    BREAK_ACCIDENT_ID: 5,
    BREAK_BREAKFAST_ID: 6,
    DELAY_CODE_TYPE_ID: 1,
    INCOMPLETE_AMOUNT_CODE_TYPE_ID: 2,
    BREAK_CODE_TYPE_ID: 3
} as const
const RUNTIME_FINISH_COMMENT_CODE_TYPES_QUERY = [
    RUNTIME_COMMENT_CODES.DELAY_CODE_TYPE_ID,
    RUNTIME_COMMENT_CODES.INCOMPLETE_AMOUNT_CODE_TYPE_ID
].join(',')
const RUNTIME_PROCESS_CODES = {
    BREAKFAST: 2,
    MACHINE_STOP_ACCIDENT: 5
} as const
const ACTIVE_REPORT_PACKAGING_JOB_REPORT_ITEM_TYPE_IDS: number[] = [
    REPORT_ITEM_TYPES.ECOM_JOB,
    REPORT_ITEM_TYPES.PM_JOB,
    REPORT_ITEM_TYPES.FB_JOB,
    REPORT_ITEM_TYPES.PRINT_FB_JOB,
    REPORT_ITEM_TYPES.PM_JOB_PRINT
]
const ACTIVE_REPORT_PACKAGING_MAX_BOX_COUNT = 13 as const
const REPORT_SUMMARY_CHART_COLORS = [
    'rgb(255, 99, 132)',
    'rgb(54, 162, 235)',
    'rgb(255, 205, 86)',
    'rgb(133, 86, 255)',
    'rgb(167, 224, 141)',
    'rgb(99, 255, 180)',
    'rgb(255, 191, 99)'
] as const

export const OPERATOR_REPORTING = {
    WORKSPACE_TYPE_IDS: [...REPORTING_WORKSPACE_TYPE_IDS, WORKSPACE_TYPES.JOB_PRODUCTS].join(','),
    QR_TYPE_CODES: OPERATOR_REPORTING_QR_TYPE_CODES,
    TASK_TYPE_IDS: {
        JOB: 1,
        ORDER: 2
    },
    REPORT_ITEM_TYPE_GROUPS: {
        JOB: OPERATOR_REPORTING_JOB_REPORT_ITEM_TYPE_IDS,
        ORDER: OPERATOR_REPORTING_ORDER_REPORT_ITEM_TYPE_IDS
    },
    DEFAULT_SHIPPING_GROUP_CODES: OPERATOR_REPORTING_DEFAULT_SHIPPING_GROUP_CODES,
    ERROR_REPORTING_PROCESS_CODE_ID: 10,
    REPORT_ITEM_ORDERS_LIMIT: 20
} as const

export const PAPER_REPORTING = {
    WORKSPACE_TYPE_IDS: REPORTING_WORKSPACE_TYPE_IDS.join(',')
} as const

export const REPORTS = {
    REPORT_ITEMS_TYPES: {
        PRODUCTION_JOB: REPORT_ITEM_TYPES.ECOM_JOB,
        PRODUCTION_ORDER: REPORT_ITEM_TYPES.ECOM_ORDER,
        PRODUCTION_SCHEDULE: REPORT_ITEM_TYPES.PM_JOB,
        FACTORY_BASE_JOB: REPORT_ITEM_TYPES.FB_JOB,
        PM_ORDER: REPORT_ITEM_TYPES.PM_ORDER,
        FB_ORDER: REPORT_ITEM_TYPES.FB_ORDER,
        SIGNATURES: REPORT_ITEM_TYPES.ORDER_SIG,
        FACTORY_BASE_JOB_PRINT: REPORT_ITEM_TYPES.PRINT_FB_JOB,
        SCHEDULE_PRINT: REPORT_ITEM_TYPES.PM_JOB_PRINT,
        CUTTING_JOB: REPORT_ITEM_TYPES.CUTTING_JOB,
        PRODUCT_JOB: REPORT_ITEM_TYPES.PRODUCT_JOB
    },
    REPORT_OBJECT_TYPES,
    REPORT_TASK_STATUSES,
    REPORT_MATERIAL_STATUSES,
    REPORT_STATUSES: {
        STARTED: 1,
        STOPPED: 90,
        FINISHED: 99
    },
    RUNTIME_COMMENT_CODES: {
        ...RUNTIME_COMMENT_CODES,
        FINISH_COMMENT_CODE_TYPES_QUERY: RUNTIME_FINISH_COMMENT_CODE_TYPES_QUERY
    },
    RUNTIME_PROCESS_CODES,
    REPORT_SHIFT_SUMMARY_STATUSES: {
        IN_PROGRESS: 1,
        FINISHED: 10,
        APPROVED: 20
    },
    REPORT_PROCESS_CODE_REVIEW_STATUSES: {
        APPROVED: 20,
        REJECTED: 30
    },
    SUMMARY_CHART_COLORS: REPORT_SUMMARY_CHART_COLORS,
    REVIEW_QUERY_PARAMS: {
        REPORT_SHIFT_SUMMARY_ID: 'reportShiftSummary_id',
        SHIPMENT_REPORT_SHIFT_SUMMARY_ID: 'shipmentReportShiftSummary_id'
    },
    WORKSPACE_STORAGE_KEYS: {
        OPERATOR: 'workspace',
        PAPER_REPORTING: 'workspace.paper.reporting'
    },
    WORKSPACE_TYPES,
    OPERATOR_REPORTING,
    PAPER_REPORTING,
    CREATE_REPORT: {
        PARAMETER_ORDER: CREATE_REPORT_PARAMETER_ORDER,
        PRODUCT_TYPE_VISIBLE_REPORT_ITEM_TYPE_IDS: CREATE_REPORT_PRODUCT_TYPE_VISIBLE_REPORT_ITEM_TYPE_IDS,
        SIGNATURES_REPORT_ITEM_TYPE_ID: REPORT_ITEM_TYPES.ORDER_SIG,
        FOLDED_SIGNATURES_PARAMETER_NAME: 'składki',
        CUT_OUT_ELASTIC_PROCESS_ID: 130
    },
    CREATE_PRINT_REPORT: {
        PARAMETER_ORDER: CREATE_PRINT_REPORT_PARAMETER_ORDER,
        PRINT_MODE_PARAMETER_NAME: 'sposób druku',
        PLATE_SET_COUNT_PARAMETER_NAME: CREATE_PRINT_REPORT_PLATE_SET_COUNT_PARAMETER_NAME,
        MAX_SHEETS_PER_PLATE_SET_PARAMETER_NAME: CREATE_PRINT_REPORT_MAX_SHEETS_PER_PLATE_SET_PARAMETER_NAME,
        SIDE_TYPES: CREATE_PRINT_REPORT_SIDE_TYPES,
        SIDE_PRIORITY: CREATE_PRINT_REPORT_SIDE_PRIORITY,
        MODE_TYPES: CREATE_PRINT_REPORT_MODE_TYPES,
        NEXT_TASKS_LIMIT: CREATE_PRINT_REPORT_NEXT_TASKS_LIMIT
    },
    ACTIVE_REPORT_PACKAGING: {
        JOB_REPORT_ITEM_TYPE_IDS: ACTIVE_REPORT_PACKAGING_JOB_REPORT_ITEM_TYPE_IDS,
        MAX_BOX_COUNT: ACTIVE_REPORT_PACKAGING_MAX_BOX_COUNT,
        TEMPORARY_LABEL_CARRIER_ID: 6
    },
    DETAIL_ORIGINS: {
        OPERATOR_REPORTING: 'operator-reporting',
        MANAGER_APPROVALS: 'manager-approvals',
        MY_REPORTS: 'my-reports',
        REPORTING_AND_ANALYSIS: 'reporting-and-analysis',
        DASHBOARD: 'dashboard'
    },
    PRINT_VARIANTS: {
        DIGITAL: 'digital',
        OFFSET: 'offset'
    },
    USER_RANKING_TYPES: {
        MONTHLY: 10,
        OVERALL: 20
    },
    WORK_TIME_GROUP_IDS: {
        BINDERY: 'introligatornia',
        SHIPPING: 'spedycja',
        SHIPMENTS_ALIAS: 'nadawanie'
    },
    WORK_TIME_SHIPMENTS_GROUP_IDS: ['spedycja', 'nadawanie'],
    QR_CODE_SIZE: REPORT_QR_CODE_SIZE,
    FIND_TASK_LIMIT: 20
} as const
